import {
    Dialog,
    DialogTitle,
    IconButton,
    TableCell,
    TableRow,
    Paper,
    DialogContent
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { AppraisalReportProps, AppraisalReportDataProps, ColumnProps } from "../types/types";
import RouteGuard from "./RouteGuard";
import AppTable from "./AppTable";

const columns: ColumnProps[] = [
    { id: "name", label: "Lead Name", width: 20, align: "left" },
    { id: "total", label: "Total", width: 20, align: "left" },
    { id: "eligible", label: "Eligible", width: 20, align: "left" },
    { id: "published", label: "Published", width: 20, align: "left" },
    { id: "pending", label: "Pending", width: 20, align: "left" },
];

const AppraisalReport: React.FC<AppraisalReportProps> = ({ open, onClose, data }) => {

    const renderRow = (row: AppraisalReportDataProps, columns: any) => {
        const isPendingZero = row.pending === 0;
    
        return (
            <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={row.code + row.name}
                sx={{
                    backgroundColor: isPendingZero ? "oklch(96.2% 0.044 156.743)" : "inherit"
                }}
            >
                {columns.map((column: any) => {
                    let value: any;
    
                    switch (column.id) {
                        default:
                            value = row[column.id as keyof AppraisalReportDataProps];
                    }
    
                    return (
                        <TableCell
                            key={String(column.id)}
                            align={column.align}
                            style={{
                                width: `${column.width}%`,
                                maxWidth: `${column.width}%`,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}
                        >
                            {value}
                        </TableCell>
                    );
                })}
            </TableRow>
        );
    };    

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            aria-labelledby="dialog-title"
        >
            <DialogTitle sx={{ m: 0, p: 2 }}>
                Report
                {onClose && (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500]
                        }}
                    >
                        <Close />
                    </IconButton>
                )}
            </DialogTitle>

            <DialogContent dividers>
                <Paper elevation={0}>
                    <AppTable
                        columns={columns}
                        rows={data}
                        page={1}
                        setPage={() => { }}
                        limit={100}
                        setLimit={() => { }}
                        count={data.length}
                        renderRow={renderRow}
                        loading={false}
                        showPagination={false}
                    />
                </Paper>
            </DialogContent>
        </Dialog>
    );
};

export default RouteGuard(AppraisalReport);
